import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function Progress(props) {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        position: 'relative',
        height: '100%',
        backgroundColor: "rgba(165, 165, 165, 0.5)",
        zIndex: (theme) => theme.zIndex.drawer + 1
      }}
      open={true}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}